
export class EvalError  {
    name:string;
    message:string;
	constructor(msg:string) {
		this.name="EVAL";
		this.message=msg;    		
	}
} 



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/error/eval-error.ts